// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { MonolithImageSizeFragmentDoc } from '../../components/useImageProps.generated';
export const NonSkuLabGrownStoneImageFragmentDoc = gql`
    fragment nonSkuLabGrownStoneImage on NonSkuLabGrown {
  image {
    __typename
    id
    size(name: MEDIUM) {
      ...monolithImageSize
    }
    size_x2: size(name: MEDIUM_X2) {
      ...monolithImageSize
    }
  }
  shapeDimension {
    __typename
    id
    image {
      __typename
      id
      size(name: MEDIUM) {
        ...monolithImageSize
      }
      size_x2: size(name: MEDIUM_X2) {
        ...monolithImageSize
      }
    }
    shape {
      __typename
      systemCode
      samplePhoto {
        __typename
        id
        size(name: MEDIUM) {
          ...monolithImageSize
        }
        size_x2: size(name: MEDIUM_X2) {
          ...monolithImageSize
        }
      }
    }
  }
}
    ${MonolithImageSizeFragmentDoc}`;
export const NonSkuGemstoneImageFragmentDoc = gql`
    fragment nonSkuGemstoneImage on NonSkuGemstone {
  image {
    __typename
    id
    size(name: MEDIUM) {
      ...monolithImageSize
    }
    size_x2: size(name: MEDIUM_X2) {
      ...monolithImageSize
    }
  }
  shapeDimension {
    __typename
    id
    shape {
      __typename
      systemCode
      samplePhoto {
        __typename
        id
        size(name: MEDIUM) {
          ...monolithImageSize
        }
        size_x2: size(name: MEDIUM_X2) {
          ...monolithImageSize
        }
      }
    }
  }
}
    ${MonolithImageSizeFragmentDoc}`;